import React, { useMemo } from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import usePaymentOptions from '~/shared/utils/usePaymentOptions';
import {
  Afterpay as BaseAfterpay,
  AfterpayConstants,
  useProductContext,
} from '~/techstyle-shared/react-components';

const Afterpay = styled(BaseAfterpay)`
  ${({ theme }) => theme.pdpStyles.afterpayStyles};
`;

function ProductDetailAfterpay({
  product: productFromProps,
  attributes: attributesFromProps,
  ...rest
}) {
  const productFromContext = useProductContext();
  const paymentOptions = usePaymentOptions();
  const product = productFromProps || productFromContext;
  const { defaultUnitPrice, promos = {} } = product;
  const hasPromo =
    Boolean(promos.promoCode) && typeof promos.promoCode === 'string';
  const amount =
    hasPromo && promos.promoPrice > 0 ? promos.promoPrice : defaultUnitPrice;
  const min = paymentOptions?.paymentSettings?.afterpay?.minimumAmount || 30;
  // data-autotag value is dictated by whether the product is above threshold
  const dataAutotag =
    amount >= min ? 'pdp-afterpay-text1' : 'pdp-afterpay-text2';

  // Set of Afterpay specific attributes to customize widget content
  const attributes = useMemo(() => {
    return {
      amount,
      min,
      showUpperLimit: false,
      modalLinkStyle: AfterpayConstants.modalLinkStyle.CIRCLED_QUESTION_ICON,
      ...attributesFromProps,
    };
  }, [amount, attributesFromProps, min]);

  return (
    <Afterpay attributes={attributes} data-autotag={dataAutotag} {...rest} />
  );
}

ProductDetailAfterpay.propTypes = {
  attributes: PropTypes.object,
  product: PropTypes.object,
};

export default ProductDetailAfterpay;
